<main class="page container-fluid">
  <section class="card border-0 shadow-sm user-card">
    <div class="card-body d-flex align-items-center gap-3">
      <div class="user-card__avatar">{{ user().initials }}</div>
      <div class="flex-grow-1">
        <p class="user-card__name mb-0">{{ user().name }}</p>
        <p class="user-card__meta mb-0">{{ user().positionName || 'CE Engineer' }}</p>
      </div>
      <span class="badge rounded user-card__sso">● Signed in via SSO</span>
    </div>
  </section>

  <div class="my-3 toolbar-row">
    <h1 class="toolbar__title mb-0">Requests for CE Engineer</h1>
    <div class="toolbar-controls">
      @if (activeTab() !== 'settings') {
        <div class="toolbar-search-group">
          <div class="search-wrapper">
            <mat-icon class="search-icon">search</mat-icon>
            <input
              class="search-input"
              type="search"
              placeholder="Search estimate or project..."
              [ngModel]="search()"
              (ngModelChange)="onSearchInputChange($event)"
              (focus)="onSearchInputFocus()"
            />
            @if (activeTab() === 'historical' && historicalSearchFieldDropdownOpen()) {
              <div class="historical-search-field-dropdown" (click)="$event.stopPropagation()">
                <p class="historical-search-field-dropdown__title mb-2">Select search field</p>
                @if (!availableHistoricalSearchFieldOptions().length) {
                  <p class="historical-search-field-dropdown__empty mb-0">All fields are already selected</p>
                } @else {
                  @for (option of availableHistoricalSearchFieldOptions(); track option.key) {
                    <button
                      type="button"
                      class="historical-search-field-dropdown__item"
                      (click)="addHistoricalSearchToken(option.key, $event)"
                    >
                      {{ option.label }}
                    </button>
                  }
                }
              </div>
            }
            @if (activeTab() === 'requests' && requestsSearchFieldDropdownOpen()) {
              <div class="historical-search-field-dropdown requests-search-field-dropdown" (click)="$event.stopPropagation()">
                <p class="historical-search-field-dropdown__title mb-2">Select search field</p>
                @if (!availableRequestsSearchFieldOptions().length) {
                  <p class="historical-search-field-dropdown__empty mb-0">All fields are already selected</p>
                } @else {
                  @for (option of availableRequestsSearchFieldOptions(); track option.key) {
                    <button
                      type="button"
                      class="historical-search-field-dropdown__item"
                      (click)="addRequestsSearchToken(option.key, $event)"
                    >
                      {{ option.label }}
                    </button>
                  }
                }
              </div>
            }
          </div>
          @if (activeTab() === 'historical' || activeTab() === 'requests') {
            <button type="button" class="btn historical-search-btn" (click)="onSearchClick()">Search</button>
          }
          @if (activeTab() === 'historical' && historicalSearchTokens().length) {
            <div class="historical-search-tokens">
              @for (token of historicalSearchTokens(); track token.key + ':' + token.value; let i = $index) {
                <span class="historical-search-token">
                  <span class="historical-search-token__label">{{ token.label }}:</span>
                  <span class="historical-search-token__value">{{ token.value }}</span>
                  <button
                    type="button"
                    class="historical-search-token__remove"
                    (click)="removeHistoricalSearchToken(i)"
                    aria-label="Remove search token"
                  >
                    ×
                  </button>
                </span>
              }
            </div>
          }
          @if (activeTab() === 'requests' && requestsSearchTokens().length) {
            <div class="historical-search-tokens">
              @for (token of requestsSearchTokens(); track token.key + ':' + token.value; let i = $index) {
                <span class="historical-search-token">
                  <span class="historical-search-token__label">{{ token.label }}:</span>
                  <span class="historical-search-token__value">{{ token.value }}</span>
                  <button
                    type="button"
                    class="historical-search-token__remove"
                    (click)="removeRequestsSearchToken(i)"
                    aria-label="Remove search token"
                  >
                    ×
                  </button>
                </span>
              }
            </div>
          }
        </div>
      }

      <!-- Tab navigation -->
      <div class="tabs-wrapper">
        <button 
          type="button" 
          class="tab-btn" 
          [class.active]="activeTab() === 'historical'"
          (click)="openTab('historical')"
        >
          <mat-icon>history</mat-icon>
          Historical
        </button>
        <button 
          type="button" 
          class="tab-btn" 
          [class.active]="activeTab() === 'requests'"
          (click)="openTab('requests')"
        >
          <mat-icon>list</mat-icon> 
          Requests
        </button>
        @if (canManageSettings()) {
          <button 
            type="button" 
            class="tab-btn" 
            [class.active]="activeTab() === 'settings'"
            (click)="openTab('settings')"
          >
            <mat-icon>settings</mat-icon>
            Settings
          </button>
        }
      </div>
    </div>
  </div>

  <!-- Historical Tab -->
  @if (activeTab() === 'historical') {
    <div class="d-flex justify-content-end mb-2">
      <button
        type="button"
        class="btn export-btn"
        [disabled]="historicalExporting()"
        (click)="exportHistoricalToExcel()"
      >
        {{ historicalExporting() ? 'Exporting...' : 'Export to Excel' }}
      </button>
    </div>
    <div class="card border-0 shadow-sm table-card" [class.table-card--filter-open]="!!historicalFilterOpenKey()">
      <table class="table table-hover align-middle mb-0 ce-table-extended">
        <thead>
          <tr>
            <th>Estimate Number</th>
            <th>Project Title</th>
            <th>
              <button type="button" class="column-filter-trigger" [class.is-active]="isHistoricalColumnFilterApplied('classOfEstimate')" (click)="toggleHistoricalFilter('classOfEstimate', $event)">
                Class of Estimate
              </button>
              @if (isHistoricalFilterOpen('classOfEstimate')) {
                <div class="column-filter-dropdown" (click)="$event.stopPropagation()">
                  @for (value of getHistoricalFilterOptions('classOfEstimate'); track value) {
                    <label class="column-filter-option">
                      <input type="checkbox" [checked]="isHistoricalFilterValueSelected('classOfEstimate', value)" (change)="toggleHistoricalFilterValue('classOfEstimate', value)" />
                      <span>{{ value }}</span>
                    </label>
                  }
                  <div class="column-filter-actions">
                    <button type="button" class="btn btn-sm btn-outline-secondary" (click)="clearHistoricalFilterValues('classOfEstimate')">Clear</button>
                    <button type="button" class="btn btn-sm btn-primary" (click)="applyHistoricalFilters()">Search</button>
                  </div>
                </div>
              }
            </th>
            <th>Link to an Estimate</th>
            <th>Project Number</th>
            <th>Project Code</th>
            <th>
              <button type="button" class="column-filter-trigger" [class.is-active]="isHistoricalColumnFilterApplied('turnaroundYear')" (click)="toggleHistoricalFilter('turnaroundYear', $event)">
                Turnaround Year
              </button>
              @if (isHistoricalFilterOpen('turnaroundYear')) {
                <div class="column-filter-dropdown" (click)="$event.stopPropagation()">
                  @for (value of getHistoricalFilterOptions('turnaroundYear'); track value) {
                    <label class="column-filter-option">
                      <input type="checkbox" [checked]="isHistoricalFilterValueSelected('turnaroundYear', value)" (change)="toggleHistoricalFilterValue('turnaroundYear', value)" />
                      <span>{{ value }}</span>
                    </label>
                  }
                  <div class="column-filter-actions">
                    <button type="button" class="btn btn-sm btn-outline-secondary" (click)="clearHistoricalFilterValues('turnaroundYear')">Clear</button>
                    <button type="button" class="btn btn-sm btn-primary" (click)="applyHistoricalFilters()">Search</button>
                  </div>
                </div>
              }
            </th>
            <th>
              <button type="button" class="column-filter-trigger" [class.is-active]="isHistoricalColumnFilterApplied('locationFacility')" (click)="toggleHistoricalFilter('locationFacility', $event)">
                Location Facility
              </button>
              @if (isHistoricalFilterOpen('locationFacility')) {
                <div class="column-filter-dropdown" (click)="$event.stopPropagation()">
                  @for (value of getHistoricalFilterOptions('locationFacility'); track value) {
                    <label class="column-filter-option">
                      <input type="checkbox" [checked]="isHistoricalFilterValueSelected('locationFacility', value)" (change)="toggleHistoricalFilterValue('locationFacility', value)" />
                      <span>{{ value }}</span>
                    </label>
                  }
                  <div class="column-filter-actions">
                    <button type="button" class="btn btn-sm btn-outline-secondary" (click)="clearHistoricalFilterValues('locationFacility')">Clear</button>
                    <button type="button" class="btn btn-sm btn-primary" (click)="applyHistoricalFilters()">Search</button>
                  </div>
                </div>
              }
            </th>
            <th>
              <button type="button" class="column-filter-trigger" [class.is-active]="isHistoricalColumnFilterApplied('locationUnit')" (click)="toggleHistoricalFilter('locationUnit', $event)">
                Location Unit
              </button>
              @if (isHistoricalFilterOpen('locationUnit')) {
                <div class="column-filter-dropdown" (click)="$event.stopPropagation()">
                  @for (value of getHistoricalFilterOptions('locationUnit'); track value) {
                    <label class="column-filter-option">
                      <input type="checkbox" [checked]="isHistoricalFilterValueSelected('locationUnit', value)" (change)="toggleHistoricalFilterValue('locationUnit', value)" />
                      <span>{{ value }}</span>
                    </label>
                  }
                  <div class="column-filter-actions">
                    <button type="button" class="btn btn-sm btn-outline-secondary" (click)="clearHistoricalFilterValues('locationUnit')">Clear</button>
                    <button type="button" class="btn btn-sm btn-primary" (click)="applyHistoricalFilters()">Search</button>
                  </div>
                </div>
              }
            </th>
            <th>Equipment Name</th>
            <th>Estimate Title</th>
            <th>AFE Number</th>
            <th>Supplement Number</th>
            <th>
              <button type="button" class="date-filter-trigger" [class.is-active]="isHistoricalDateFilterApplied('projectCompletionDate')" (click)="toggleHistoricalDateFilter('projectCompletionDate', $event)">
                Project Completion Date
              </button>
              @if (isHistoricalDateFilterOpen('projectCompletionDate')) {
                <div class="date-filter-dropdown" (click)="$event.stopPropagation()">
                  <label class="date-filter-field">
                    <span>From</span>
                    <input
                      type="date"
                      [ngModel]="historicalSelectedDateRanges().projectCompletionDate.startDate"
                      (ngModelChange)="updateHistoricalDateFilterValue('projectCompletionDate', 'startDate', $event || '')"
                    />
                  </label>
                  <label class="date-filter-field">
                    <span>To</span>
                    <input
                      type="date"
                      [ngModel]="historicalSelectedDateRanges().projectCompletionDate.endDate"
                      (ngModelChange)="updateHistoricalDateFilterValue('projectCompletionDate', 'endDate', $event || '')"
                    />
                  </label>
                  <div class="date-filter-actions">
                    <button type="button" class="btn btn-sm btn-outline-secondary" (click)="clearHistoricalDateFilter('projectCompletionDate')">Clear</button>
                    <button type="button" class="btn btn-sm btn-primary" (click)="applyHistoricalDateFilter('projectCompletionDate')">Search</button>
                  </div>
                </div>
              }
            </th>
            <th>TASP DST (USD$)</th>
            <th>
              <button type="button" class="date-filter-trigger" [class.is-active]="isHistoricalDateFilterApplied('dateReceived')" (click)="toggleHistoricalDateFilter('dateReceived', $event)">
                Date Received
              </button>
              @if (isHistoricalDateFilterOpen('dateReceived')) {
                <div class="date-filter-dropdown" (click)="$event.stopPropagation()">
                  <label class="date-filter-field">
                    <span>From</span>
                    <input
                      type="date"
                      [ngModel]="historicalSelectedDateRanges().dateReceived.startDate"
                      (ngModelChange)="updateHistoricalDateFilterValue('dateReceived', 'startDate', $event || '')"
                    />
                  </label>
                  <label class="date-filter-field">
                    <span>To</span>
                    <input
                      type="date"
                      [ngModel]="historicalSelectedDateRanges().dateReceived.endDate"
                      (ngModelChange)="updateHistoricalDateFilterValue('dateReceived', 'endDate', $event || '')"
                    />
                  </label>
                  <div class="date-filter-actions">
                    <button type="button" class="btn btn-sm btn-outline-secondary" (click)="clearHistoricalDateFilter('dateReceived')">Clear</button>
                    <button type="button" class="btn btn-sm btn-primary" (click)="applyHistoricalDateFilter('dateReceived')">Search</button>
                  </div>
                </div>
              }
            </th>
            <th>
              <button type="button" class="date-filter-trigger" [class.is-active]="isHistoricalDateFilterApplied('deadlineDate')" (click)="toggleHistoricalDateFilter('deadlineDate', $event)">
                Deadline Date
              </button>
              @if (isHistoricalDateFilterOpen('deadlineDate')) {
                <div class="date-filter-dropdown" (click)="$event.stopPropagation()">
                  <label class="date-filter-field">
                    <span>From</span>
                    <input
                      type="date"
                      [ngModel]="historicalSelectedDateRanges().deadlineDate.startDate"
                      (ngModelChange)="updateHistoricalDateFilterValue('deadlineDate', 'startDate', $event || '')"
                    />
                  </label>
                  <label class="date-filter-field">
                    <span>To</span>
                    <input
                      type="date"
                      [ngModel]="historicalSelectedDateRanges().deadlineDate.endDate"
                      (ngModelChange)="updateHistoricalDateFilterValue('deadlineDate', 'endDate', $event || '')"
                    />
                  </label>
                  <div class="date-filter-actions">
                    <button type="button" class="btn btn-sm btn-outline-secondary" (click)="clearHistoricalDateFilter('deadlineDate')">Clear</button>
                    <button type="button" class="btn btn-sm btn-primary" (click)="applyHistoricalDateFilter('deadlineDate')">Search</button>
                  </div>
                </div>
              }
            </th>
            <th>
              <button type="button" class="date-filter-trigger" [class.is-active]="isHistoricalDateFilterApplied('startDate')" (click)="toggleHistoricalDateFilter('startDate', $event)">
                Start Date
              </button>
              @if (isHistoricalDateFilterOpen('startDate')) {
                <div class="date-filter-dropdown" (click)="$event.stopPropagation()">
                  <label class="date-filter-field">
                    <span>From</span>
                    <input
                      type="date"
                      [ngModel]="historicalSelectedDateRanges().startDate.startDate"
                      (ngModelChange)="updateHistoricalDateFilterValue('startDate', 'startDate', $event || '')"
                    />
                  </label>
                  <label class="date-filter-field">
                    <span>To</span>
                    <input
                      type="date"
                      [ngModel]="historicalSelectedDateRanges().startDate.endDate"
                      (ngModelChange)="updateHistoricalDateFilterValue('startDate', 'endDate', $event || '')"
                    />
                  </label>
                  <div class="date-filter-actions">
                    <button type="button" class="btn btn-sm btn-outline-secondary" (click)="clearHistoricalDateFilter('startDate')">Clear</button>
                    <button type="button" class="btn btn-sm btn-primary" (click)="applyHistoricalDateFilter('startDate')">Search</button>
                  </div>
                </div>
              }
            </th>
            <th>
              <button type="button" class="date-filter-trigger" [class.is-active]="isHistoricalDateFilterApplied('dateCompleted')" (click)="toggleHistoricalDateFilter('dateCompleted', $event)">
                Date Completed
              </button>
              @if (isHistoricalDateFilterOpen('dateCompleted')) {
                <div class="date-filter-dropdown" (click)="$event.stopPropagation()">
                  <label class="date-filter-field">
                    <span>From</span>
                    <input
                      type="date"
                      [ngModel]="historicalSelectedDateRanges().dateCompleted.startDate"
                      (ngModelChange)="updateHistoricalDateFilterValue('dateCompleted', 'startDate', $event || '')"
                    />
                  </label>
                  <label class="date-filter-field">
                    <span>To</span>
                    <input
                      type="date"
                      [ngModel]="historicalSelectedDateRanges().dateCompleted.endDate"
                      (ngModelChange)="updateHistoricalDateFilterValue('dateCompleted', 'endDate', $event || '')"
                    />
                  </label>
                  <div class="date-filter-actions">
                    <button type="button" class="btn btn-sm btn-outline-secondary" (click)="clearHistoricalDateFilter('dateCompleted')">Clear</button>
                    <button type="button" class="btn btn-sm btn-primary" (click)="applyHistoricalDateFilter('dateCompleted')">Search</button>
                  </div>
                </div>
              }
            </th>
            <th>Requestor</th>
            <th>Department (Cost Center)</th>
            <th>Department Group L1</th>
            <th>Department Group L2</th>
            <th>Department Group L3</th>
            <th>TCO Estimator</th>
            <th>TCO Secondary Estimator</th>
            <th>TCO Tertiary Estimator</th>
            <th>TCO Quaternary Estimator</th>
            <th>TCO Reviewer</th>
            <th>Sent to</th>
            <th>
              <button type="button" class="column-filter-trigger" [class.is-active]="isHistoricalColumnFilterApplied('contingencyCalculationMethod')" (click)="toggleHistoricalFilter('contingencyCalculationMethod', $event)">
                Contingency Calculation Method
              </button>
              @if (isHistoricalFilterOpen('contingencyCalculationMethod')) {
                <div class="column-filter-dropdown" (click)="$event.stopPropagation()">
                  @for (value of getHistoricalFilterOptions('contingencyCalculationMethod'); track value) {
                    <label class="column-filter-option">
                      <input type="checkbox" [checked]="isHistoricalFilterValueSelected('contingencyCalculationMethod', value)" (change)="toggleHistoricalFilterValue('contingencyCalculationMethod', value)" />
                      <span>{{ value }}</span>
                    </label>
                  }
                  <div class="column-filter-actions">
                    <button type="button" class="btn btn-sm btn-outline-secondary" (click)="clearHistoricalFilterValues('contingencyCalculationMethod')">Clear</button>
                    <button type="button" class="btn btn-sm btn-primary" (click)="applyHistoricalFilters()">Search</button>
                  </div>
                </div>
              }
            </th>
            <th>
              <button type="button" class="column-filter-trigger" [class.is-active]="isHistoricalColumnFilterApplied('status')" (click)="toggleHistoricalFilter('status', $event)">
                Status
              </button>
              @if (isHistoricalFilterOpen('status')) {
                <div class="column-filter-dropdown" (click)="$event.stopPropagation()">
                  @for (value of getHistoricalFilterOptions('status'); track value) {
                    <label class="column-filter-option">
                      <input type="checkbox" [checked]="isHistoricalFilterValueSelected('status', value)" (change)="toggleHistoricalFilterValue('status', value)" />
                      <span>{{ value }}</span>
                    </label>
                  }
                  <div class="column-filter-actions">
                    <button type="button" class="btn btn-sm btn-outline-secondary" (click)="clearHistoricalFilterValues('status')">Clear</button>
                    <button type="button" class="btn btn-sm btn-primary" (click)="applyHistoricalFilters()">Search</button>
                  </div>
                </div>
              }
            </th>
            <th>
              <button type="button" class="column-filter-trigger" [class.is-active]="isHistoricalColumnFilterApplied('agileMethodology')" (click)="toggleHistoricalFilter('agileMethodology', $event)">
                Agile Methodology
              </button>
              @if (isHistoricalFilterOpen('agileMethodology')) {
                <div class="column-filter-dropdown" (click)="$event.stopPropagation()">
                  @for (value of getHistoricalFilterOptions('agileMethodology'); track value) {
                    <label class="column-filter-option">
                      <input type="checkbox" [checked]="isHistoricalFilterValueSelected('agileMethodology', value)" (change)="toggleHistoricalFilterValue('agileMethodology', value)" />
                      <span>{{ value }}</span>
                    </label>
                  }
                  <div class="column-filter-actions">
                    <button type="button" class="btn btn-sm btn-outline-secondary" (click)="clearHistoricalFilterValues('agileMethodology')">Clear</button>
                    <button type="button" class="btn btn-sm btn-primary" (click)="applyHistoricalFilters()">Search</button>
                  </div>
                </div>
              }
            </th>
            <th>Comments</th>
            <th>ENG, USD%</th>
            <th>ENG, KZT%</th>
            <th>ENG, EUR%</th>
            <th>ENG, GBP%</th>
            <th>PROC, USD%</th>
            <th>PROC, KZT%</th>
            <th>PROC, EUR%</th>
            <th>PROC, GBP%</th>
            <th>CONST, USD%</th>
            <th>CONST, KZT%</th>
            <th>CONST, EUR%</th>
            <th>CONST, GBP%</th>
            <th>OWN, USD%</th>
            <th>OWN, KZT%</th>
            <th>OWN, EUR%</th>
            <th>OWN, GBP%</th>
            <th>CNTG, USD%</th>
          </tr>
        </thead>
        <tbody>
          @for (request of filteredRequests(); track request.estimateNumber) {
            <tr>
              <td class="fw-bold">{{ request.estimateNumber }}</td>
              <td>{{ request.projectTitle }}</td>
              <td>{{ request.classOfEstimate || '-' }}</td>
              <td>{{ request.linkToAnEstimate || '-' }}</td>
              <td>{{ request.projectNumber || '-' }}</td>
              <td>{{ request.projectCode || '-' }}</td>
              <td>{{ request.turnaroundYear || '-' }}</td>
              <td>{{ request.locationFacility || '-' }}</td>
              <td>{{ request.locationUnit || '-' }}</td>
              <td>{{ request.equipmentName || '-' }}</td>
              <td>{{ request.estimateTitle || '-' }}</td>
              <td>{{ request.afeNumber || '-' }}</td>
              <td>{{ request.supplementNumber || '-' }}</td>
              <td>{{ request.projectCompletionDate ? (request.projectCompletionDate | date:'yyyy-MM-dd') : '-' }}</td>
              <td>{{ request.taspdst || '-' }}</td>
              <td>{{ request.dateReceived ? (request.dateReceived | date:'yyyy-MM-dd') : '-' }}</td>
              <td>{{ request.deadlineDate ? (request.deadlineDate | date:'yyyy-MM-dd') : '-' }}</td>
              <td>{{ request.startDate ? (request.startDate | date:'yyyy-MM-dd') : '-' }}</td>
              <td>{{ request.dateCompleted ? (request.dateCompleted | date:'yyyy-MM-dd') : '-' }}</td>
              <td>{{ request.requestor || '-' }}</td>
              <td>{{ request.departmentCostCenter || '-' }}</td>
              <td>{{ request.departmentGroupL1 || '-' }}</td>
              <td>{{ request.departmentGroupL2 || '-' }}</td>
              <td>{{ request.departmentGroupL3 || '-' }}</td>
              <td>{{ request.tcoEstimator || '-' }}</td>
              <td>{{ request.tcoSecondaryEstimator || '-' }}</td>
              <td>{{ request.tcoTertiaryEstimator || '-' }}</td>
              <td>{{ request.tcoQuaternaryEstimator || '-' }}</td>
              <td>{{ request.tcoReviewer || '-' }}</td>
              <td>{{ request.sentTo || '-' }}</td>
              <td>{{ request.contingencyCalculationMethod || '-' }}</td>
              <td>
                <span [class]="'badge rounded-pill ' + statusClass(historicalStatusLabel(request))">
                  ● {{ historicalStatusLabel(request) }}
                </span>
              </td>
              <td>{{ request.agileMethodology || '-' }}</td>
              <td>{{ request.comments || '-' }}</td>
              <td>{{ request.engUsd || '-' }}</td>
              <td>{{ request.engKzt || '-' }}</td>
              <td>{{ request.engEur || '-' }}</td>
              <td>{{ request.engGbp || '-' }}</td>
              <td>{{ request.procUsd || '-' }}</td>
              <td>{{ request.procKzt || '-' }}</td>
              <td>{{ request.procEur || '-' }}</td>
              <td>{{ request.procGbp || '-' }}</td>
              <td>{{ request.constUsd || '-' }}</td>
              <td>{{ request.constKzt || '-' }}</td>
              <td>{{ request.constEur || '-' }}</td>
              <td>{{ request.constGbp || '-' }}</td>
              <td>{{ request.ownUsd || '-' }}</td>
              <td>{{ request.ownKzt || '-' }}</td>
              <td>{{ request.ownEur || '-' }}</td>
              <td>{{ request.ownGbp || '-' }}</td>
              <td>{{ request.cntgUsd || '-' }}</td>
            </tr>
          } @empty {
            <tr>
              <td class="text-center text-secondary py-5" colspan="50">
                {{ (!search().trim() && !isHistoricalColumnFilterApplied('status') && totalHistoricalRecords() === 0)
                  ? 'No data available.'
                  : 'No CE requests match your search.' }}
              </td>
            </tr>
          }
        </tbody>
      </table>
    </div>
  }

  <!-- Requests Tab -->
  @if (activeTab() === 'requests') {
    <div class="card border-0 shadow-sm table-card" [class.table-card--filter-open]="statusDropdownOpen() || dateFilterOpen()">
      <table class="table table-hover align-middle mb-0 ce-table">
        <thead>
          <tr>
            <th>Estimate Number</th>
            <th>Project Title</th>
            <th>Estimate Title</th>
            <th>
              <button type="button" class="requests-date-filter-trigger" [class.is-active]="hasAppliedRequestedDateFilters()" (click)="toggleRequestsDateFilter($event)">
                CE Request Date
              </button>
              @if (dateFilterOpen()) {
                <div class="requests-date-filter-dropdown" (click)="$event.stopPropagation()">
                  <label class="date-filter-field">
                    <span>From</span>
                    <input
                      type="date"
                      [ngModel]="selectedStartDate()"
                      (ngModelChange)="selectedStartDate.set($event || '')"
                    />
                  </label>
                  <label class="date-filter-field">
                    <span>To</span>
                    <input
                      type="date"
                      [ngModel]="selectedEndDate()"
                      (ngModelChange)="selectedEndDate.set($event || '')"
                    />
                  </label>
                  <div class="date-filter-actions">
                    <button type="button" class="btn btn-sm btn-outline-secondary" (click)="clearRequestedDateFilters()">Clear</button>
                    <button type="button" class="btn btn-sm btn-primary" (click)="applyRequestedDateFilters()">Search</button>
                  </div>
                </div>
              }
            </th>
            <th>Requestor</th>
            <th>
              <button type="button" class="column-filter-trigger" [class.is-active]="hasAppliedRequestedStatusFilters()" (click)="toggleStatusDropdown()">
                Status
              </button>
              @if (statusDropdownOpen()) {
                <div class="column-filter-dropdown status-dropdown" (click)="$event.stopPropagation()">
                  @for (status of statuses; track status) {
                    <label class="column-filter-option">
                      <input type="checkbox" [checked]="isRequestedStatusFilterSelected(status)" (change)="toggleRequestedStatusFilterValue(status)" />
                      <span>{{ status }}</span>
                    </label>
                  }
                  <div class="column-filter-actions">
                    <button type="button" class="btn btn-sm btn-outline-secondary" (click)="clearRequestedStatusFilters()">Clear</button>
                    <button type="button" class="btn btn-sm btn-primary" (click)="applyRequestedStatusFilters()">Search</button>
                  </div>
                </div>
              }
            </th>
            <th>Action</th>
            <th>Estimator</th>
          </tr>
        </thead>
        <tbody>
          @if (projectsLoading()) {
            <tr>
              <td class="text-center text-secondary py-5" colspan="8">
                Loading...
              </td>
            </tr>
          } @else {
            @for (project of filteredProjects(); track project.id) {
              <tr>
                <td class="fw-bold cell--estimate">{{ formatEstimateNumber(project) }}</td>
                <td>{{ project.projectTitle || '-' }}</td>
                <td>{{ project.estimateTitle || '-' }}</td>
                <td>{{ getRequestedProjectDate(project) ? (getRequestedProjectDate(project) | date: 'yyyy-MM-dd') : '-' }}</td>
                <td>{{ project.requestor || '-' }}</td>
                <td>
                  <span [class]="'badge rounded-pill ' + statusClass(projectStatusLabel(project.projectStatusType))">
                    ● {{ projectStatusLabel(project.projectStatusType) }}
                  </span>
                </td>
                <td>
                  <button type="button" class="btn btn-link p-0 link" (click)="viewProject(project)">
                    View
                  </button>
                </td>
                <td>
                  <div class="estimator-cell">
                    <div class="assigned-control">
                      <mat-icon class="assigned-icon">person_outline</mat-icon>
                      <input
                        #projectAssignedCeInput
                        class="assigned-select"
                        [matAutocomplete]="projectAssignedCeOptions"
                        #projectAssignedCeTrigger="matAutocompleteTrigger"
                        [ngModel]="getProjectAssignedUser(project)"
                        (ngModelChange)="setProjectAssignedUser(project, $event, projectAssignedCeInput)"
                        (focus)="openProjectAssigneeOptions(project, projectAssignedCeTrigger)"
                        (click)="openProjectAssigneeOptions(project, projectAssignedCeTrigger)"
                        (blur)="closeProjectAssigneeOptions(project)"
                        [readonly]="!isProjectEstimatorEditing(project) || isEstimatorChangeLocked(project)"
                        placeholder="—"
                        autocomplete="off"
                      />
                      <mat-autocomplete #projectAssignedCeOptions="matAutocomplete">
                        @for (ceUser of getFilteredCeUsersForProject(project); track ceUser) {
                          <mat-option [value]="ceUser">{{ ceUser }}</mat-option>
                        }
                      </mat-autocomplete>
                    </div>
                    <button
                      type="button"
                      class="estimator-action-btn"
                      [disabled]="isProjectEstimatorActionDisabled(project)"
                      (click)="onProjectEstimatorAction(project, projectAssignedCeTrigger, projectAssignedCeInput)"
                    >
                      {{ getProjectEstimatorActionLabel(project) }}
                    </button>
                    @if (isProjectEstimatorEditing(project) && !isEstimatorChangeLocked(project)) {
                      <button
                        type="button"
                        class="estimator-cancel-btn"
                        [disabled]="isProjectEstimatorSaving(project)"
                        (click)="cancelProjectEstimatorChange(project, projectAssignedCeTrigger)"
                      >
                        Cancel
                      </button>
                    }
                  </div>
                </td>
              </tr>
            } @empty {
              <tr>
                <td class="text-center text-secondary py-5" colspan="8">
                  {{ (!requestsAppliedSearchTokens().length && !hasAppliedRequestedStatusFilters() && !hasAppliedRequestedDateFilters() && totalProjectRecords() === 0)
                    ? 'No data available.'
                    : 'No CE requests match your search.' }}
                </td>
              </tr>
            }
          }
        </tbody>
      </table>
    </div>
  }

  <!-- Settings Tab -->
  @if (activeTab() === 'settings' && canManageSettings()) {
    <div class="card border-0 shadow-sm p-4 settings-card">
      <div class="settings-toolbar">
        <h2 class="settings-title mb-0">Dictionaries Management</h2>
        <p class="settings-subtitle mb-0">Manage dropdown and questionnaire source values.</p>
      </div>

      <div class="settings-layout">
        <aside class="dictionary-list">
          @for (dictionary of dictionaries(); track dictionary.key) {
            <button
              type="button"
              class="dictionary-item"
              [class.active]="selectedDictionaryKey() === dictionary.key"
              (click)="selectDictionary(dictionary.key)"
            >
              <span>{{ dictionary.name }}</span>
              <span class="dictionary-count">{{ dictionary.values.length }}</span>
            </button>
            @if (dictionary.key === 'questionnaire' && selectedDictionaryKey() === 'questionnaire') {
              <div class="questionnaire-class-submenu">
                @for (classNumber of questionnaireClasses; track classNumber) {
                  <button
                    type="button"
                    class="questionnaire-class-item"
                    [class.active]="selectedQuestionnaireClass() === classNumber"
                    (click)="selectQuestionnaireClass(classNumber)"
                  >
                    <span>Class {{ classNumber }}</span>
                  </button>
                }
              </div>
            }
          }
        </aside>

        <section class="dictionary-editor">
          @if (selectedDictionary(); as dictionary) {
            @if (selectedDictionaryKey() === 'questionnaire') {
              <div class="editor-head">
                <h3 class="editor-title mb-0">Questionnaire · Class {{ selectedQuestionnaireClass() }}</h3>
                <div class="editor-head-actions">
                  <div class="editor-meta">{{ questionnaireGroups().length }} groups</div>
                  @if (showSaveSuccess()) {
                    <span class="save-success" role="status" aria-live="polite">Saved successfully</span>
                  }
                  @if (questionnaireApiError()) {
                    <span class="dictionary-field-error" role="alert">{{ questionnaireApiError() }}</span>
                  }
                  @if (hasDictionaryChanges()) {
                    <button type="button" class="btn btn-success btn-save" [disabled]="hasDictionaryValidationErrors()" (click)="saveDictionary()">
                      Save
                    </button>
                  }
                </div>
              </div>

              <div class="editor-tools questionnaire-tools">
                <div class="add-row add-row--questionnaire">
                  <div class="add-row--questionnaire-top">
                    <input
                      class="dictionary-add-input"
                      [class.is-invalid]="questionnaireAddDescriptionRequired()"
                      type="text"
                      placeholder="Add new question"
                      [ngModel]="questionnaireAddDescription()"
                      (ngModelChange)="onQuestionnaireAddDescriptionChange($event)"
                      (keyup.enter)="addQuestionnaireQuestion()"
                    />
                    <div class="questionnaire-add-group-field">
                      <select
                        class="dictionary-add-input"
                        [class.is-invalid]="questionnaireAddGroupRequired()"
                        [ngModel]="questionnaireAddGroupId()"
                        (ngModelChange)="onQuestionnaireAddGroupChange($event)"
                      >
                        <option [ngValue]="null">Select group</option>
                        @for (group of questionnaireAddGroupOptions(); track group.id) {
                          <option [ngValue]="group.id">{{ group.groupName || 'Ungrouped' }}</option>
                        }
                      </select>
                    </div>
                    <button type="button" class="btn btn-primary btn-add" (click)="addQuestionnaireQuestion()">
                      Add
                    </button>
                    <label class="questionnaire-flag">
                      <input
                        type="checkbox"
                        [ngModel]="questionnaireAddMandatory()"
                        (ngModelChange)="questionnaireAddMandatory.set($event)"
                      />
                      Is Mandatory
                    </label>
                    <label class="questionnaire-flag">
                      <input
                        type="checkbox"
                        [ngModel]="questionnaireAddAttachment()"
                        (ngModelChange)="questionnaireAddAttachment.set($event)"
                      />
                      Has Attachments
                    </label>
                    <label class="questionnaire-flag">
                      <input
                        type="checkbox"
                        [ngModel]="questionnaireAddMandatoryAttachment()"
                        (ngModelChange)="questionnaireAddMandatoryAttachment.set($event)"
                      />
                      Is Mandatory Attachment
                    </label>
                  </div>
                </div>
              </div>

              <div class="questionnaire-groups">
                @for (group of questionnaireGroups(); track group.groupName || $index; let groupIndex = $index) {
                  <section class="questionnaire-group">
                    <h4 class="questionnaire-group-title">{{ group.groupName || 'Ungrouped' }}</h4>
                    <div class="questionnaire-question-list">
                      @for (question of group.questions; track question.id ?? $index; let questionIndex = $index) {
                        <div class="questionnaire-question-row">
                          <input
                            class="dictionary-value-input"
                            [class.is-invalid]="!!questionnaireValueErrors()[groupIndex + ':' + questionIndex]"
                            type="text"
                            [ngModel]="question.description"
                            (ngModelChange)="updateQuestionnaireQuestion(groupIndex, questionIndex, 'description', $event)"
                          />
                          <label class="questionnaire-flag">
                            <input
                              type="checkbox"
                              [ngModel]="question.isMandatory"
                              (ngModelChange)="updateQuestionnaireQuestion(groupIndex, questionIndex, 'isMandatory', $event)"
                            />
                            Is Mandatory
                          </label>
                          <label class="questionnaire-flag">
                            <input
                              type="checkbox"
                              [ngModel]="question.hasAttachment"
                              (ngModelChange)="updateQuestionnaireQuestion(groupIndex, questionIndex, 'hasAttachment', $event)"
                            />
                            Has Attachments
                          </label>
                          <label class="questionnaire-flag">
                            <input
                              type="checkbox"
                              [ngModel]="question.isMandatoryAttachment"
                              (ngModelChange)="updateQuestionnaireQuestion(groupIndex, questionIndex, 'isMandatoryAttachment', $event)"
                            />
                            Is Mandatory Attachment
                          </label>
                          <button type="button" class="btn btn-link p-0 text-danger fw-semibold" (click)="removeQuestionnaireQuestion(groupIndex, questionIndex)">
                            Remove
                          </button>
                          @if (questionnaireValueErrors()[groupIndex + ':' + questionIndex]) {
                            <p class="dictionary-field-error mb-0" role="alert">{{ questionnaireValueErrors()[groupIndex + ':' + questionIndex] }}</p>
                          }
                        </div>
                      }
                    </div>
                  </section>
                } @empty {
                  <p class="text-secondary mb-0">No questions available for this class of estimate.</p>
                }
              </div>
            } @else {
            <div class="editor-head">
              <h3 class="editor-title mb-0">{{ dictionary.name }}</h3>
              <div class="editor-head-actions">
                <div class="editor-meta">{{ dictionary.values.length }} values</div>
                @if (showSaveSuccess()) {
                  <span class="save-success" role="status" aria-live="polite">Saved successfully</span>
                }
                @if (dictionaryApiError()) {
                  <span class="dictionary-field-error" role="alert">{{ dictionaryApiError() }}</span>
                }
              @if (hasDictionaryChanges()) {
                  <button type="button" class="btn btn-success btn-save" [disabled]="hasDictionaryValidationErrors()" (click)="saveDictionary()">
                    Save
                  </button>
                }
              </div>
            </div>

            <div class="editor-tools">
              <input
                class="dictionary-search"
                type="search"
                placeholder="Search value..."
                [ngModel]="dictionarySearch()"
                (ngModelChange)="dictionarySearch.set($event)"
              />
              @if (!isReadonlyDictionary(selectedDictionaryKey())) {
                <div class="add-row">
                  <input
                    class="dictionary-add-input"
                    type="text"
                    placeholder="Add new value"
                    [ngModel]="newDictionaryValue()"
                    (ngModelChange)="onNewDictionaryValueChange($event)"
                    (keyup.enter)="addDictionaryValue()"
                  />
                  <button type="button" class="btn btn-primary btn-add" (click)="addDictionaryValue()">
                    Add
                  </button>
                </div>
                @if (dictionaryAddError()) {
                  <p class="dictionary-add-error mb-0" role="alert">{{ dictionaryAddError() }}</p>
                }
              }
            </div>

            <div class="dictionary-table-wrap">
              <table class="table table-sm align-middle mb-0 dictionary-table">
                <thead>
                  <tr>
                    <th>#</th>
                    <th>Value</th>
                    @if (!isReadonlyDictionary(selectedDictionaryKey())) {
                      <th>Action</th>
                    }
                  </tr>
                </thead>
                <tbody>
                  @for (row of filteredDictionaryValues(); track row.index) {
                    <tr>
                      <td class="value-index">{{ row.index + 1 }}</td>
                      <td>
                        <input
                          class="dictionary-value-input"
                          [class.is-invalid]="!!dictionaryValueErrors()[row.index]"
                          type="text"
                          [ngModel]="row.value"
                          (ngModelChange)="updateDictionaryValue(row.index, $event)"
                          [readonly]="isReadonlyDictionary(selectedDictionaryKey())"
                        />
                        @if (dictionaryValueErrors()[row.index]) {
                          <p class="dictionary-field-error mb-0" role="alert">{{ dictionaryValueErrors()[row.index] }}</p>
                        }
                      </td>
                      @if (!isReadonlyDictionary(selectedDictionaryKey())) {
                        <td>
                          <button
                            type="button"
                            class="btn btn-link p-0 text-danger fw-semibold"
                            (click)="askRemoveDictionaryValue(row.index)"
                          >
                            Remove
                          </button>
                        </td>
                      }
                    </tr>
                  } @empty {
                    <tr>
                      <td colspan="3" class="text-center text-secondary py-4">
                        No values match current search.
                      </td>
                    </tr>
                  }
                </tbody>
              </table>
            </div>
            @if (pendingRemoveDictionaryIndex() !== null) {
              <div class="modal-backdrop" animate.enter="modal-backdrop-enter" animate.leave="modal-backdrop-leave" (click)="cancelRemoveDictionaryValue()"></div>
              <div class="confirm-modal" animate.enter="confirm-modal-enter" animate.leave="confirm-modal-leave" role="dialog" aria-modal="true" aria-labelledby="remove-dictionary-value-title">
                <p class="confirm-modal__title" id="remove-dictionary-value-title">Remove Value</p>
                <p class="confirm-modal__message">
                  Are you sure you want to remove
                  <strong>{{ getPendingRemoveDictionaryValue() || 'this value' }}</strong>
                  from the dictionary?
                </p>
                <div class="confirm-modal__actions">
                  <button type="button" class="btn-confirm btn-confirm--cancel" (click)="cancelRemoveDictionaryValue()">Cancel</button>
                  <button type="button" class="btn-confirm btn-confirm--confirm" (click)="confirmRemoveDictionaryValue()">Remove</button>
                </div>
              </div>
            }
            }
          }
        </section>
      </div>
    </div>
  }

  @if (activeTab() !== 'settings') {
    <footer class="d-flex flex-wrap align-items-center justify-content-between gap-3 mt-3 pager">
      @if (activeTab() === 'requests') {
        <span class="pager__summary">
          Showing {{ filteredProjectsTotal() ? (currentPageRequests() - 1) * pageSize + 1 : 0 }}–{{ filteredProjectsTotal() ? (currentPageRequests() - 1) * pageSize + filteredProjects().length : 0 }} of {{ filteredProjectsTotal() }} requests
        </span>
        <ngb-pagination
          [collectionSize]="filteredProjectsTotal()"
          [pageSize]="pageSize"
          [page]="currentPageRequests()"
          (pageChange)="currentPageRequests.set($event)"
          [maxSize]="5"
          [boundaryLinks]="false"
        />
      } @else {
        <span class="pager__summary">
          Showing {{ filteredTotal() ? (currentPageHistorical() - 1) * pageSize + 1 : 0 }}–{{ filteredTotal() ? (currentPageHistorical() - 1) * pageSize + filteredRequests().length : 0 }} of {{ filteredTotal() }} requests
        </span>
        <ngb-pagination
          [collectionSize]="filteredTotal()"
          [pageSize]="pageSize"
          [page]="currentPageHistorical()"
          (pageChange)="currentPageHistorical.set($event)"
          [maxSize]="5"
          [boundaryLinks]="false"
        />
      }
    </footer>
  }
</main>
